module.exports = __webpack_public_path__ + "img/4.e7144d1c.jpg";